// @flow
import React from 'react';

import './style.pcss';

type Props = {
  text: string,
  linkInfo: {
    merchantId: string,
    projectId: string,
    landingId: number
  }
};

const AffiliateButton = ({ text, linkInfo }: Props) => {
  const campaignPart = `utm_source=sitebuilder&utm_medium=footer_affiliate_link&utm_campaign=${linkInfo.merchantId}&utm_content=${linkInfo.projectId}&utm_term=${linkInfo.landingId}`;

  return (
    <div className='ui-site-affiliate-button'>
      <a
        className='ui-site-affiliate-button__link'
        // TODO вынести BASEURL в конфиг
        href={`https://influencer.xsolla.com/api/programs/show?merchant=${linkInfo.merchantId}&project=${linkInfo.projectId}&${campaignPart}`}
        target='_blank'
        rel='noopener noreferrer'
      >
        <span className='ui-site-affiliate-button__text'>{text}</span>
        <div className='ui-site-affiliate-button__icon' />
      </a>
    </div>
  );
};

export default AffiliateButton;
